<template>
  <div style="overflow:hidden">

  <headerNav />
  <div class="bs-site-container"  >
    <aside>
      <div class="right-buttons-wrap" style="margin-top: 50px;"> 
        <!-- <div class="tournaments-panel__trigger" @click="asideFunction(0)">
          <font-awesome-icon color="white" :icon="['fas', 'trophy']"
            class="tournaments-panel__trigger-icon icon sprite-icons" />
        </div> -->
        <div style="z-index: 10; position: relative;" class="help-panel__trigger" @click="asideFunction(1)">
  <span>HELP</span>
</div>

        <nav  class="lang-selector is-position-1" @click="flags = flags === false ? true : false;" :class="{ 'is-opened': flags }">
          <a  
           
           class="nuxt-link-exact-active nuxt-link-active is-en" 
           title="english"
           style="cursor:pointer"
           
         >

         
            <!-- <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><g fill="#c74841"><path d="m55 47 2.95 1.97a30.967 30.967 0 0 1 -5.95 6.71v-6.68z"/><path d="m28 18v4h-2l-1-2z"/><path d="m58 27 1-1-1-3-5-4v-1h-4l-4 1h-4l-1-2h-5l-2 3h4l1 2-3 1h-2l-5 5v3h1l4-4h2l2 4h3v2h-1-4l-1-1h-2l-6 5v4l2 2h5v1l1 2v3l1 5h4l3-5v-1l-1-2 3-2v-2h-5v-6h2l1 3h3v-3l-1-2 4 1v4h1l3-3 1 4v4h2v-4h2v-1l-2-2h1l1-3v-2h2v-3l-1-1z"/><path d="m18 13-4 1-6 5-4 4v2h2v9l2.08 1.38.92.62 3 4v4l2 1 1 6h2l3-4v-2l1-2-3-3-2-3h-3-1l-1-3h-2v-2h3v-2l1-1 1-1v-2l3-1v-1l-1-2h-3l-1 2-2-1 1-2 1-1 1-1 1 1 2-1v-2l-1-1h2 2v3 2h2v-2l3-1 3-4v-1l1-1v-2z"/></g><path d="m1 32a31 31 0 1 1 56.95 16.97l-2.95-1.97-3 2v6.68a31 31 0 0 1 -51-23.68zm23-14 3-4v-1l1-1v-2l-10 3-4 1-6 5-4 4v2h2v9l2.08 1.38.92.62 3 4v4l2 1 1 6h2l3-4v-2l1-2-3-3-2-3h-4l-1-3h-2v-2h3v-2l1-1 1-1v-2l3-1v-1l-1-2h-3l-1 2-2-1 1-2 1-1 1-1 1 1 2-1v-2l-1-1h4v5h2v-2zm1 2 1 2h2v-4zm19 22h-5v-6h2l1 3h3v-3l-1-2 4 1v4h1l3-3 1 4v4h2v-4h2v-1l-2-2h1l1-3v-2h2v-3l-1-1v-1l1-1-1-3-5-4v-1h-4l-4 1h-4l-1-2h-5l-2 3h4l1 2-3 1h-2l-5 5v3h1l4-4h2l2 4h3v2h-5l-1-1h-2l-6 5v4l2 2h5v1l1 2v3l1 5h4l3-5v-1l-1-2 3-2z" fill="#34c1ad"/><path d="m52 50.59v5.09a30.967 30.967 0 0 0 5.95-6.71l-1.268-.847a30.846 30.846 0 0 1 -4.682 2.467z" fill="#ad3a34"/><path d="m39 54 .606-1.01a31.229 31.229 0 0 1 -4.9-.449l.294 1.459z" fill="#ad3a34"/><path d="m4 23v2h2v9l2.08 1.38.92.62 3 4v4l2 1 1 6h2l3-4v-1.322a31.135 31.135 0 0 1 -7.13-8.678h-.87l-1-3h-2v-2h1.658a30.8 30.8 0 0 1 -1.385-14.061l-1.273 1.061z" fill="#ad3a34"/><path d="m9 34h2l1 3h.87a30.79 30.79 0 0 1 -2.212-5h-1.658z" fill="#21abab"/><path d="m40 53c-.132 0-.262-.008-.394-.01l-.606 1.01h-4l-.292-1.459a30.878 30.878 0 0 1 -14.708-6.863v1.322l-3 4h-2l-1-6-2-1v-4l-3-4-.92-.62-2.08-1.38v-9h-2v-2l4-4 1.273-1.061a30.79 30.79 0 0 1 3.045-9.889 31 31 0 1 0 39.682 47.63v-5.09a30.9 30.9 0 0 1 -12 2.41z" fill="#21abab"/><path d="m57.95 48.97a30.873 30.873 0 0 0 1.715-3.007 31.261 31.261 0 0 1 -2.983 2.16z" fill="#21abab"/><path d="m42.69 10h-5.69v-3c3.65.05 5.14 1.92 5.69 3z" fill="#96e0ff"/><path d="m20.25 7.67-3.5-6.67h3.5l7.51 6.35c-2.42.13-5.02.27-7.51.41z" fill="#d4d4d4"/><path d="m37 10h5.69a3.235 3.235 0 0 1 .31.75s0 2.25-3.5 2.25h-7.38l-11.2 8h-4.67l6.54-8h-17.08a3.384 3.384 0 0 1 -3.45-2.51l-1.26-6.49h2.62l4.38 4.5s5.77-.37 12.25-.74c2.49-.14 5.09-.28 7.51-.41 3.98-.2 7.45-.35 9.11-.35h.13z" fill="#e3e3e3"/><path d="m11.6 16h3.4 2 2 .79l-.79.966v.67l3.79-4.636h-4.79l-4 1z" fill="#ad3a34"/><path d="m14.885 22-1.635 2h3.75l-1-2z" fill="#ad3a34"/><path d="m14 14 4-1h-10.485a31.01 31.01 0 0 0 -2.07 3h6.155z" fill="#21abab"/><path d="m20.92 21h-4.67l2.75-3.364v-.67l-4.115 5.034h1.115l1 2h.92l11.2-8h7.38c3.5 0 3.5-2.25 3.5-2.25a3.235 3.235 0 0 0 -.31-.75v-.008c-.064 0-.12.008-.186.008h-7.384l-11.12 7.943v.057z" fill="#21abab"/><path d="m23.07 6a2 2 0 0 1 -1.664-.891l-2.739-4.109h-1.917l3.5 6.67v.09c2.49-.14 5.09-.28 7.51-.41l-1.597-1.35z" fill="#bfbfbf"/><path d="m6.342 12a3 3 0 0 1 -2.91-2.272l-1.432-5.728h-1l1.26 6.49a3.384 3.384 0 0 0 3.45 2.51h16.957l1.333-1z" fill="#bfbfbf"/><path d="m41 12h-8l-1 1 .018.073.1-.073h7.382c3.5 0 3.5-2.25 3.5-2.25s-.022-.09-.075-.235a2 2 0 0 1 -1.925 1.485z" fill="#bfbfbf"/><path d="m39 9h3a6.038 6.038 0 0 0 -4-1.922v.922a1 1 0 0 0 1 1z" fill="#b3f5ff"/></svg> -->
          <img src="./assets/left.png" style="filter: brightness(0) invert(1);" />
           </a>
          <a  
           
            class="nuxt-link-exact-active nuxt-link-active is-en" 
            style="cursor:pointer"
            title="english"
            @click="$changeLanguage('en')"
          >

          
              <img
                      src="./assets/flags/gb.png"
                      alt="gb country flag"
                      class="c-flag-icon bs-c-site-sidebar__list-icon"
                    />
            
            </a>

              <a  class="is-ru" title="russian"  @click="$changeLanguage('ru')" style="cursor:pointer">
                
                <img
                      src="./assets/flags/ru.png"
                      alt="ru country flag"
                      class="c-flag-icon bs-c-site-sidebar__list-icon"
                    />
            </a>

              <a   class="is-zh-CN" title="french" @click="$changeLanguage('fr')" style="cursor:pointer">
                
                <svg
                      viewBox="0 0 64 64"
                      height="50px"
                      width="50px"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m1.9 32c0 13.1 8.4 24.2 20 28.3v-56.6c-11.6 4.1-20 15.2-20 28.3z"
                        fill="#428bc1"
                      />
                      <path
                        d="m61.9 32c0-13.1-8.3-24.2-20-28.3v56.6c11.7-4.1 20-15.2 20-28.3"
                        fill="#ed4c5c"
                      />
                      <path
                        d="m21.9 60.3c3.1 1.1 6.5 1.7 10 1.7s6.9-.6 10-1.7v-56.6c-3.1-1.1-6.4-1.7-10-1.7s-6.9.6-10 1.7z"
                        fill="#fff"
                      />
                    </svg>
              </a>

              <a class="is-ja" title="German" @click="$changeLanguage('de')" style="cursor:pointer">
              
                <svg
                      viewBox="0 0 64 64"
                      height="50px"
                      width="50px"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m31.9 2c-13.1 0-24.2 8.4-28.3 20h56.6c-4.1-11.6-15.2-20-28.3-20z"
                        fill="#3e4347"
                      />
                      <path
                        d="m31.9 62c13.1 0 24.2-8.3 28.3-20h-56.6c4.1 11.7 15.2 20 28.3 20z"
                        fill="#ffe62e"
                      />
                      <path
                        d="m3.6 22c-1.1 3.1-1.7 6.5-1.7 10s.6 6.9 1.7 10h56.6c1.1-3.1 1.7-6.5 1.7-10s-.6-6.9-1.7-10z"
                        fill="#ed4c5c"
                      />
                    </svg>
              </a>

              <a  class="is-pt-BR" title="Português" @click="$changeLanguage('de')" style="cursor:pointer">
                
                <img
                      src="./assets/flags/br.png"
                      alt="br country flag"
                      class="c-flag-icon bs-c-site-sidebar__list-icon"
                    />
              </a>

              <a class="" title="Tunisian" @click="$changeLanguage('tn')" style="cursor:pointer">
                
               <svg
                      viewBox="0 0 64 64"
                      height="50px"
                      width="50px"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="32" cy="32" fill="#ed4c5c" r="30" />
                      <circle cx="32" cy="32" fill="#fff" r="17.3" />
                      <circle cx="32" cy="32" fill="#ed4c5c" r="13" />
                      <circle cx="35.5" cy="32" fill="#fff" r="10.4" />
                      <path
                        d="m38.4 32 3.4-4.6-5.4 1.8-3.3-4.6v5.7l-5.4 1.7 5.4 1.7v5.7l3.3-4.6 5.4 1.8z"
                        fill="#ed4c5c"
                      />
                    </svg>
              </a>
            
              <a  class="is-zh-CN"  title="Turkish" @click="$changeLanguage('tr')" style="cursor:pointer">
                
                <svg
                      viewBox="0 0 64 64"
                      height="50px"
                      width="50px"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="32" cy="32" fill="#ed4c5c" r="30" />
                      <g fill="#fff">
                        <path
                          d="m41.3 39 .1-5.4-5.4-1.6 5.4-1.6-.1-5.4 3.3 4.3 5.4-1.6-3.3 4.3 3.3 4.3-5.4-1.6z"
                        />
                        <path
                          d="m33.2 44c-6.6 0-11.9-5.4-11.9-12s5.3-12 11.9-12c2.5 0 4.8.8 6.8 2.1-2.7-3.1-6.7-5.1-11.2-5.1-8.2 0-14.8 6.7-14.8 15s6.6 15 14.8 15c4.5 0 8.5-2 11.2-5.1-1.9 1.3-4.2 2.1-6.8 2.1"
                        />
                      </g>
                    </svg>
              </a>


        </nav>
      </div>
      <div class="help-panel" :style="{ width: help }">
        <div class="help-panel__header">
          <span class="help-panel__title">HELP</span>
          <button class="c-button help-panel__close has-icon color-transparent size-m" @click="close()">
            <font-awesome-icon :icon="['fas', 'xmark']" class="c-button__icon icon sprite-icons" />
          </button>
        </div>
        <div class="help-panel__content">
          <ul class="help-panel__nav">
            <li class="help-panel__nav-item">
              <router-link to="/faq" class="help-panel__nav-link">
                <font-awesome-icon :icon="['fas', 'circle-question']"
                  class="help-panel__nav-icon icon sprite-help-panel" />

                FAQ
                <font-awesome-icon :icon="['fas', 'angle-right']" class="help-panel__nav-icon--arrow icon sprite-icons" />

              </router-link>
            </li>
            <li class="help-panel__nav-item">
              <router-link to="/payments" class="help-panel__nav-link">
                <font-awesome-icon :icon="['fas', 'money-bill']" class="help-panel__nav-icon icon sprite-help-panel" />

                Payments
                <font-awesome-icon :icon="['fas', 'angle-right']" class="help-panel__nav-icon--arrow icon sprite-icons" />
              </router-link>
            </li>
          </ul> <!---->
          <section data-v-5c6daa6e="" class="c-help" style="text-align:left;">
            <div data-v-5c6daa6e="" class="c-help-content">
              <h4 data-v-5c6daa6e="" class="c-help-content__title" style="margin:0;">
                <font-awesome-icon size="xl" :icon="['fas', 'comments']"
                  class="c-help-content__title-icon icon sprite-help-panel" />
                <span data-v-5c6daa6e="" class="c-help-content__title-text">
                  Premium Support
                </span>
              </h4>
              <p data-v-5c6daa6e="" class="c-help-content__text">
                For general questions and issues, please contact our premium support via the email below or via live chat.
              </p>
              <div data-v-5c6daa6e="" class="c-help-content__cta"><a data-v-5c6daa6e="" href="mailto:support@tunwin88.com"
                  rel="nofollow" class="c-help-content__link">
                  support@tunwin88.com
                </a> <span data-v-5c6daa6e="" class="c-help-content__link">
                  Live Chat
                </span></div>
            </div>
          </section>
        </div>
        <div id="lcqualitybadge" class="lcqualitybadge"><a style="text-decoration: none;user-select:none;"
            href="https://lc.chat/qb/3736711/2" target="_blank"><svg width="240" height="144" viewBox="0 0 444 258"
              xmlns="http://www.w3.org/2000/svg">
              <defs>
                <rect id="quality-a" width="436" height="248" rx="40"></rect>
                <path d="M0 0h435v8c0 22.09139-17.90861 40-40 40H40C17.90861 48 0 30.09139 0 8V0z" id="b"></path>
                <path id="c" d="M27.2 0l8.4 17 18.8 2.7L40.8 33 44 51.7 27.2 43l-16.8 8.7L13.6 33 0 19.7 18.8 17l8.4-17">
                </path>
              </defs>
              <g fill="none" fill-rule="evenodd">
                <g transform="translate(4 4)">
                  <use fill="transparent" xlink:href="#quality-a"></use>
                  <rect stroke="#3A3A3A" stroke-width="4" width="438" height="252" rx="40"></rect>
                </g>
                <g fill="#D7D7D7" y="27"><text opacity=".8"
                    font-family="-apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif" font-size="24"
                    transform="translate(0 148)" x="50%" y="50%">
                    <tspan y="27" text-anchor="middle">4.5/5.0 - 2536 ratings</tspan>
                  </text></g>
                <g transform="translate(6 206)">
                  <path fill="transparent"
                    d="M-1.5-1.5h437V8c0 22.9198171-18.580183 41.5-41.5 41.5H40C17.0801829 49.5-1.5 30.9198171-1.5 8v-9.5z">
                  </path>
                </g><text opacity=".8"
                  font-family="-apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif" font-size="22"
                  letter-spacing=".191304" fill="#D7D7D7" transform="translate(4 204)">
                  <tspan x="181" y="34">Verified by LiveChat</tspan>
                </text><text opacity=".8"
                  font-family="-apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif" font-size="22"
                  fill="#D7D7D7" transform="translate(4 204)">
                  <tspan x="47" y="34">Dec. 2023</tspan>
                </text><text font-family="-apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif"
                  font-size="28" font-weight="500" fill="#D7D7D7" transform="translate(0 4)" x="50%" y="50%">
                  <tspan y="51" text-anchor="middle" letter-spacing="0">EXCELLENT SERVICE</tspan>
                </text>
                <g fill-rule="nonzero" fill="#D46D39">
                  <path fill="#D46D39" fill-rule="nonzero"
                    d="M79.2 80l8.4 17 18.8 2.7L92.8 113l3.2 18.7-16.8-8.8-16.8 8.7 3.2-18.7L52 99.7 70.8 97l8.4-17">
                  </path>
                  <path fill="#D46D39" fill-rule="nonzero"
                    d="M150.2 80l8.4 17 18.8 2.7-13.6 13.3 3.2 18.7-16.8-8.8-16.8 8.7 3.2-18.7L123 99.7l18.8-2.7 8.4-17">
                  </path>
                  <path fill="#D46D39" fill-rule="nonzero"
                    d="M221.2 80l8.4 17 18.8 2.7-13.6 13.3 3.2 18.7-16.8-8.8-16.8 8.7 3.2-18.7L194 99.7l18.8-2.7 8.4-17">
                  </path>
                  <path fill="#D46D39" fill-rule="nonzero"
                    d="M292.2 80l8.4 17 18.8 2.7-13.6 13.3 3.2 18.7-16.8-8.8-16.8 8.7 3.2-18.7L265 99.7l18.8-2.7 8.4-17">
                  </path>
                  <g transform="translate(336 80)">
                    <mask id="d" fill="#fff">
                      <use xlink:href="#c"></use>
                    </mask>
                    <use fill="#D46D39" fill-rule="nonzero" xlink:href="#c"></use>
                    <path fill="#ECEFF1" d="M27 0h28v52H27z" mask="url(#d)"></path>
                  </g>
                </g>
              </g>
            </svg></a></div>
        <div class="help-panel__social-icons">
          <ul class="social-icons">
            <li class="social-icons__item">
              <a
                :href="socialData?.teligram"
                rel="nofollow"
                target="_blank"
                class="social-icons__icon is-telegram"
              ></a>
            </li>
            <li class="social-icons__item">
              <a
              :href="socialData?.twitter"

                rel="nofollow"
                target="_blank"
                class="social-icons__icon is-twitter"
              ></a>
            </li>
            <li class="social-icons__item" 
    style="display:flex;justify-content: center;align-items: center;"
            
            >
  <a
    :href="socialData?.facebook"
    rel="nofollow"
    target="_blank"
    class=" "
    style="display:flex;justify-content: center;align-items: center;background-color:#2B2740;height:50px;width:50px;border-radius: 50% "
  >
  <svg viewBox="0 0 425 512" xmlns="http://www.w3.org/2000/svg">
  <path fill="#FFFFFF" d="M245.5 205q-3.5 0-8.5 3.25t-5 9.75v13h39.5v52H232v105h-52V283h-39.5v-52H180v-26q0-10 4.5-19.5t12.75-16.75T216.5 157t24-4.5h44V205h-39z"/>
</svg>

</a>
</li>

<li class="social-icons__item" 
    style="display:flex;justify-content: center;align-items: center;"
            
            >
  <a
  :href="socialData?.instagram"

    rel="nofollow"
    target="_blank"
    class=" "
    style="display:flex;justify-content: center;align-items: center;background-color:#2B2740;height:50px;width:50px;border-radius: 50% "
  >
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m7.46494 1.066c1.17334-.05378 1.54734-.066 4.53506-.066 2.9883 0 3.3617.01283 4.5344.066 1.1715.05317 1.9715.23956 2.6712.5115.7339.27631 1.3987.70924 1.9482 1.26867.5595.54943.9925 1.21429 1.2687 1.94822.2719.69972.4577 1.49967.5115 2.67055.0538 1.17334.066 1.54734.066 4.53506 0 2.9877-.0128 3.3617-.066 4.5351-.0532 1.1708-.2396 1.9708-.5115 2.6705-.2811.723-.6576 1.3371-1.2687 1.9482-.5494.5595-1.2143.9925-1.9482 1.2687-.6997.2719-1.4997.4577-2.6705.5115-1.1734.0538-1.5474.066-4.5351.066-2.98772 0-3.36172-.0128-4.53506-.066-1.17088-.0532-1.97083-.2396-2.67055-.5115-.72295-.2811-1.33711-.6576-1.94822-1.2687-.55953-.5494-.99249-1.2143-1.26867-1.9482-.27194-.6997-.45772-1.4997-.5115-2.6705-.05378-1.1734-.066-1.5468-.066-4.5351 0-2.98833.01283-3.36172.066-4.53444.05317-1.1715.23956-1.97145.5115-2.67117.27631-.73388.70924-1.39871 1.26867-1.94822.54942-.55953 1.21428-.99249 1.94822-1.26867.69972-.27194 1.49967-.45772 2.67055-.5115zm8.98026 1.98c-1.1599-.05256-1.5082-.06417-4.4452-.06417s-3.28533.01161-4.44522.06417c-1.0725.04889-1.65489.22794-2.04234.37889-.51333.19922-.88.43755-1.265.82255-.38438.385-.62333.75167-.82255 1.265-.15095.38745-.33.96984-.37889 2.04234-.05256 1.15989-.06417 1.50822-.06417 4.44522s.01161 3.2853.06417 4.4452c.04889 1.0725.22794 1.6549.37889 2.0424.17622.4778.4573.91.82255 1.265.3549.3652.78717.6463 1.265.8225.38745.151.96984.33 2.04234.3789 1.15989.0526 1.50761.0642 4.44522.0642 2.9376 0 3.2853-.0116 4.4452-.0642 1.0725-.0489 1.6549-.2279 2.0424-.3789.5133-.1992.88-.4375 1.265-.8225.3652-.3549.6463-.7872.8225-1.265.151-.3875.33-.9699.3789-2.0424.0526-1.1599.0642-1.5082.0642-4.4452s-.0116-3.28533-.0642-4.44522c-.0489-1.0725-.2279-1.65489-.3789-2.04234-.1992-.51333-.4375-.88-.8225-1.265-.385-.38438-.7517-.62333-1.265-.82255-.3875-.15095-.9699-.33-2.0424-.37889zm-5.8497 12.3449c.4453.1845.9225.2794 1.4045.2794.9735 0 1.907-.3867 2.5953-1.075.6884-.6883 1.0751-1.6219 1.0751-2.5953s-.3867-1.907-1.0751-2.59532c-.6883-.68832-1.6218-1.07502-2.5953-1.07502-.482 0-.9592.09494-1.4045.27939-.4454.18445-.84997.4548-1.19079.79563-.34082.34082-.61118.74542-.79563 1.19072s-.27938.9226-.27938 1.4046.09493.9593.27938 1.4046.45481.8499.79563 1.1907.74539.6112 1.19079.7956zm-2.59345-7.38889c1.06033-1.06033 2.49845-1.65602 3.99795-1.65602 1.4996 0 2.9377.59569 3.998 1.65602s1.656 2.49849 1.656 3.99799-.5957 2.9376-1.656 3.998c-1.0603 1.0603-2.4984 1.656-3.998 1.656-1.4995 0-2.93762-.5957-3.99795-1.656-1.06033-1.0604-1.65602-2.4985-1.65602-3.998s.59569-2.93766 1.65602-3.99799zm10.90565-.81363c.2506-.25065.3914-.59059.3914-.94505 0-.35447-.1408-.69441-.3914-.94505-.2507-.25064-.5906-.39145-.9451-.39145-.3544 0-.6944.14081-.945.39145-.2507.25064-.3915.59058-.3915.94505 0 .35446.1408.6944.3915.94505.2506.25064.5906.39145.945.39145.3545 0 .6944-.14081.9451-.39145z" fill="white" fill-rule="evenodd"/></svg>
</a>
</li>

<li class="social-icons__item" 
    style="display:flex;justify-content: center;align-items: center;"
            
            >
  <a
  :href="socialData?.whatsapp"

    rel="nofollow"
    target="_blank"
    class=" "
    style="display:flex;justify-content: center;align-items: center;background-color:#2B2740;height:50px;width:50px;border-radius: 50% "
  >
  <svg height="28" fill="white" viewBox="0 0 512 512" width="28" xmlns="http://www.w3.org/2000/svg"><path d="m414.73 97.1a222.14 222.14 0 0 0 -157.79-65.1c-122.94 0-223.02 99.58-223.07 222a220.61 220.61 0 0 0 29.78 111l-31.65 115 118.25-30.87a223.63 223.63 0 0 0 106.6 27h.09c122.93 0 223-99.59 223.06-222a220.18 220.18 0 0 0 -65.27-157.03zm-157.79 341.56h-.08a185.75 185.75 0 0 1 -94.36-25.72l-6.77-4-70.17 18.32 18.73-68.09-4.41-7a183.46 183.46 0 0 1 -28.35-98.17c0-101.73 83.21-184.5 185.48-184.5a185 185 0 0 1 185.33 184.64c-.04 101.74-83.21 184.52-185.4 184.52zm101.69-138.19c-5.57-2.78-33-16.2-38.08-18.05s-8.83-2.78-12.54 2.78-14.4 18-17.65 21.75-6.5 4.16-12.07 1.38-23.54-8.63-44.83-27.53c-16.57-14.71-27.75-32.87-31-38.42s-.35-8.56 2.44-11.32c2.51-2.49 5.57-6.48 8.36-9.72s3.72-5.56 5.57-9.26.93-6.94-.46-9.71-12.54-30.08-17.18-41.19c-4.53-10.82-9.12-9.35-12.54-9.52-3.25-.16-7-.2-10.69-.2a20.53 20.53 0 0 0 -14.86 6.94c-5.11 5.56-19.51 19-19.51 46.28s20 53.68 22.76 57.38 39.3 59.73 95.21 83.76a323.11 323.11 0 0 0 31.78 11.68c13.35 4.22 25.5 3.63 35.1 2.2 10.71-1.59 33-13.42 37.63-26.38s4.64-24.06 3.25-26.37-5.11-3.71-10.69-6.48z" fill-rule="evenodd"/></svg>
</a>
</li>

<li class="social-icons__item" 
    style="display:flex;justify-content: center;align-items: center;"
            
            >
  <a
  :href="socialData?.linkedin"

    rel="nofollow"
    target="_blank"
    class=" "
    style="display:flex;justify-content: center;align-items: center;background-color:#2B2740;height:50px;width:50px;border-radius: 50% "
  >
  <svg height="26" fill="white" viewBox="0 0 32 32" width="26" xmlns="http://www.w3.org/2000/svg"><path d="m8.268 28h-5.805v-18.694h5.805zm-2.906-21.244c-1.856 0-3.362-1.538-3.362-3.394s1.505-3.362 3.362-3.362 3.362 1.505 3.362 3.362c0 1.856-1.506 3.394-3.362 3.394zm24.632 21.244h-5.792v-9.1c0-2.169-.044-4.95-3.018-4.95-3.018 0-3.481 2.356-3.481 4.794v9.256h-5.799v-18.694h5.567v2.55h.081c.775-1.469 2.668-3.019 5.492-3.019 5.875 0 6.955 3.869 6.955 8.894v10.269z"/></svg>
</a>
</li>
          </ul>
        </div>
      </div>
      <div class="tournaments-panel" :style="{ width: tournament }">
        <div class="tournaments-panel__header"><span class="tournaments-panel__title">Tournaments</span>
          <button class="c-button tournaments-panel__close has-icon color-transparent size-m" @click="close()">
            <font-awesome-icon :icon="['fas', 'xmark']" class="c-button__icon icon sprite-icons" />
          </button>
        </div>
        <div class="tournaments-panel__body">
          <div class="tournament-panel__swiper">
            <button class="c-button tournaments-panel-swiper-arrow is-prev has-icon color-dark-purple size-m" style="display: none;"><!----> 
              <font-awesome-icon :icon="['fas', 'arrow-left']" class="c-button__icon icon sprite-icons"/>
            </button> 
            <button class="c-button tournaments-panel-swiper-arrow is-next has-icon color-dark-purple size-m"><!----> 
              <font-awesome-icon :icon="['fas', 'arrow-right']" class="c-button__icon icon sprite-icons"/>
            </button>
            <ul class="bs-c-swiper">
              <li class="tournament-panel__swiper-item is-slot-wars is-active">
                <div class="tournament-panel__swiper-box"><img
                    src="https://d3oqh5ecy4r3n8.cloudfront.net/img/logo-en.7b02b47.png" alt="Slot Wars"
                    class="tournament-panel__swiper-img"> <!----></div>
              </li>
              <li class="tournament-panel__swiper-item is-table-wars">
                <div class="tournament-panel__swiper-box"><img
                    src="https://d3oqh5ecy4r3n8.cloudfront.net/img/logo-en.433139f.png" alt="Table Wars"
                    class="tournament-panel__swiper-img"> <!----></div>
              </li>
            </ul>
          </div>
          <div class="tournaments-panel__counter">
            <div class="countdown-timer tournaments-panel__timer is-inline">
              <font-awesome-icon :icon="['fas', 'clock']" style="color: #ffffff;" class="countdown-timer__icon icon sprite-icons"/>
              <span class="countdown-timer__label">Ending in</span> <span class="countdown-timer__value"><span
                  class="countdown-timer__value-block is-day"><span class="countdown-timer__value-time">1</span>
                  d
                </span> <span class="countdown-timer__value-block"><span class="countdown-timer__value-time">03</span>
                  :
                </span> <span class="countdown-timer__value-block"><span class="countdown-timer__value-time">57</span>
                  :
                </span> <span class="countdown-timer__value-block"><span class="countdown-timer__value-time">16</span>

                </span></span></div> 
                <button @click="openModal" class="c-button tournaments-panel__counter-btn size-m"><!---->
              <span>Deposits</span> <!---->
            </button>
          </div>
          <ul class="bs-c-leaderboard tournaments-panel__results is-large">
            <li class="bs-c-leaderboard__row">
              <h2 class="bs-c-leaderboard__title">
                Leaderboard
              </h2>
            </li>
            <li class="bs-c-leaderboard__row is-heading">
              <div class="bs-c-leaderboard__column">
                Place
              </div>
              <div class="bs-c-leaderboard__column">
                Player
              </div>
              <div class="bs-c-leaderboard__column is-points">
                Points
              </div>
              <div class="bs-c-leaderboard__column is-prize">
                Prize
              </div>
            </li>
            <li class="bs-c-leaderboard__row">
              <div class="bs-c-leaderboard__column">
                1.
              </div>
              <div class="bs-c-leaderboard__column">
                MNS****
              </div>
              <div class="bs-c-leaderboard__column is-points">
                166085
              </div>
              <div class="bs-c-leaderboard__column is-prize">
                1500 EUR
              </div>
            </li>
            <li class="bs-c-leaderboard__row">
              <div class="bs-c-leaderboard__column">
                2.
              </div>
              <div class="bs-c-leaderboard__column">
                mi***
              </div>
              <div class="bs-c-leaderboard__column is-points">
                74407
              </div>
              <div class="bs-c-leaderboard__column is-prize">
                1000 EUR
              </div>
            </li>
            <li class="bs-c-leaderboard__row">
              <div class="bs-c-leaderboard__column">
                3.
              </div>
              <div class="bs-c-leaderboard__column">
                Firs***
              </div>
              <div class="bs-c-leaderboard__column is-points">
                72864
              </div>
              <div class="bs-c-leaderboard__column is-prize">
                500 EUR
              </div>
            </li>
            <li class="bs-c-leaderboard__row">
              <div class="bs-c-leaderboard__column">
                4.
              </div>
              <div class="bs-c-leaderboard__column">
                rsin***
              </div>
              <div class="bs-c-leaderboard__column is-points">
                69236
              </div>
              <div class="bs-c-leaderboard__column is-prize">
                300 EUR
              </div>
            </li>
            <li class="bs-c-leaderboard__row">
              <div class="bs-c-leaderboard__column">
                5.
              </div>
              <div class="bs-c-leaderboard__column">
                Sy***
              </div>
              <div class="bs-c-leaderboard__column is-points">
                50558
              </div>
              <div class="bs-c-leaderboard__column is-prize">
                200 EUR
              </div>
            </li>
           
          
          
            
            
        
          </ul>
        </div>
      </div>
      
    </aside>
    
    <router-view />
  </div>
  <div v-if="!userLogin">
      <LoginPolicyShow/>

    </div>
    <div>
      <CookiePolicyShow />

    </div>
</div>

<div class="show-data">
<MobileFooter/>
    </div>
  <!-- <footerBottom /> -->
</template>

<script>
import './assets/css/home.css';
import headerNav from './parts/header.vue'
import { inject } from 'vue';

import { provide } from 'vue';
import {
  modalState,
  openModal1,
  closeModal1,
  openModal2,
  closeModal2,
  openModal3,
  closeModal3,
  setStep1,
  setStep2,
  setStep3,
} from './modalState.js';
import CookiePolicyShow from './components/CookiePolicyShow.vue';
import LoginPolicyShow from './components/LoginPolicyShow.vue';
import MobileFooter from './parts/MobileFooter.vue';
export default {
  name: 'App',
  data() {
    return {
      help: '0px',
      tournament: '0px',
      flags: false,
      LogoFeviconData: null,
      socialData:{},
      userLogin:false,

    };
  },
  setup() {
    provide('modalState', modalState);
    provide('openModal1', openModal1);
    provide('closeModal1', closeModal1);
    provide('openModal2', openModal2);
    provide('closeModal2', closeModal2);
    provide('openModal3', openModal3);
    provide('closeModal3', closeModal3);
    provide('setStep1', setStep1);
    provide('setStep2', setStep2);
    provide('setStep3', setStep3);
  },
  components: {
    headerNav,
    // footerBottom
    CookiePolicyShow,
    LoginPolicyShow,
    MobileFooter
  },
  methods: {
    openModal() {
      openModal1(); // Call the openModal1 function from modalState.js
    },
    asideFunction(n) {
      this.help = n === 1 ? '340px' : '0px';
      this.tournament = n === 0 ? '340px' : '0px';
    },
    close() {
      this.help = '0px';
      this.tournament = '0px';
    },
    t(key) {
      return this.$t(key);
    },
    async fetchLogoFavicon() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_KEY}/api/setting/get-setting/6532c132ed5efb8183a66703?site_auth_key=${process.env.VUE_APP_API_SITE_AUTH_KEY}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch favicon data");
        }

        const LogoFeviData = await response.json();
        // console.log("logo and favicon Data:", LogoFeviData);
        this.socialData = LogoFeviData.data;
        this.LogoFeviconData = LogoFeviData.data.site_fav_icon;
        this.updateFavicon(this.LogoFeviconData);
      } catch (error) {
        console.error("Error fetching favicon data:", error);
      }
    },
    
    updateFavicon(url) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = url;
    }
  },
  mounted() {
  
  this.fetchLogoFavicon();
  const userToken = localStorage.getItem("userToken");
    const usernameToken = localStorage.getItem("usernameToken");
    if(userToken&&usernameToken){
      this.userLogin=true
    }
  // console.log(this.$i18n, "checkinh"); // Log $i18n to check if it's defined

}
}
const script = document.createElement("script");
script.async = true;
script.src = "https://embed.tawk.to/661b88091ec1082f04e21b1d/1hrdompm4";
script.charset = "UTF-8";
script.setAttribute("crossorigin", "*");
document.head.appendChild(script);
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>

<style scoped>
.help-panel__trigger {
  align-items: center;
  background-color: #00bd71;
  border-radius: 6px 0 0 6px;
  cursor: pointer;
  display: flex;
  height: 99px;
  justify-content: center;
  margin-bottom: 5px;
  text-align: center;
  text-transform: uppercase;
  transition: background-color .3s ease;
  white-space: nowrap;
  width: 40px;
}

.help-panel__trigger>span {
  color: #fff;
  font-size: 22px;
  font-weight: 400;
  margin: 0;
  text-align: center;
  transform: rotate(90deg);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none
}

.lang-ru .help-panel__trigger>span {
  font-size: 16px
}

.lang-pt-BR .help-panel__trigger>span {
  font-size: 20px
}

.help-panel__trigger.is-out {
  right: -50px
}

.help-panel__trigger.clicked {
  right: -44px
}

.help-panel__trigger:hover {
  background-color: #0dd182
}

.tournaments-panel__trigger {
  align-items: center;
  background: #e5b400;
  border-radius: 6px 0 0 6px;
  cursor: pointer;
  display: flex;
  font-size: 18px;
  height: 40px;
  justify-content: center;
  margin-bottom: 5px;
  text-align: center;
  transition: all .3s ease;
  width: 40px
}

.tournaments-panel__trigger.is-out {
  right: -44px
}

.tournaments-panel__trigger.is-out span {
  opacity: 0
}

.tournaments-panel__trigger>span {
  font-size: 24px
}

.os-win .tournaments-panel__trigger>span {
  transform: translateY(5%)
}

.tournaments-panel__trigger>span:before {
  color: #fff
}

.page-users_sign_up .tournaments-panel__trigger {
  display: none
}

:-webkit-full-screen .tournaments-panel__trigger {
  display: none
}

.tournaments-panel__trigger.is-panel-opened {
  right: -44px
}

.tournaments-panel__trigger-icon {
  fill: #fff;
  height: 18px;
  width: 20px
}

/* .lang-selector {
  align-content: stretch;
  align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 44px;
  margin-left:0px;
  justify-content: flex-start;
  margin-bottom: 5px;
  position: absolute;
  transform: translate3d(-5px, 0, 0);
  transition: transform .5s;
  white-space: nowrap
} */
.lang-selector.is-opened {
    transform: translate3d(-304px,0,0);
}
.lang-selector {
    align-content: stretch;
    align-items: stretch;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 44px;
    margin-left: 0;
    justify-content: flex-start;
    margin-bottom: 5px;
    position: absolute;
    transform: translate3d(-5px,0,0);
    transition: transform .5s;
    white-space: nowrap
}
@media(max-width:768px) {
  .lang-selector {
    display: none
  }
}


@media (min-width: 1024px) {
  .show-data{
    display:none
  }
  
}

.lang-selector.is-opened a:not(:last-child) .c-flag-icon {
  border-radius: 6px
}

.lang-selector a {
  display: inline-block;
  height: 40px;
  margin-left: 3px;
  order: 2;
  -webkit-text-decoration: none;
  text-decoration: none;
  width: 40px
}

.lang-selector a.nuxt-link-active {
  order: 1
}

.lang-selector .c-flag-icon {
  border-radius: 6px 0 0 6px;
  height: 40px;
  width: 40px
}

.is-desktop .bs-c-lang-selector .is-active-locale {
  display: none
}

.is-desktop .bs-c-lang-selector .bs-c-lang-selector__item-link {
  padding-left: 10px
}

.bs-c-lang-selector__item {
  align-items: center;
  display: flex;
  min-height: 50px
}

.bs-c-lang-selector__item-link {
  align-items: center;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: flex;
  height: 100%;
  min-height: 40px;
  padding: 0 13px;
  -webkit-text-decoration: none;
  text-decoration: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  width: 100%
}

@media(max-width:1366px) {
  .bs-c-lang-selector__item-link {
    padding: 0 20px
  }
}

@media(hover:hover) {
  .bs-c-lang-selector__item-link:hover {
    background: radial-gradient(62.27% 184.22% at 87.42% 42.5%, #342f4b 0, #2b2740 100%)
  }

  .bs-c-lang-selector__item-link:hover .bs-c-lang-selector__item-text {
    color: #fff;
    font-weight: 400
  }
}

.bs-c-site-sidebar__list-icon.is-checkmark {
  align-items: center;
  background: #00bd71;
  border-radius: 50%;
  display: flex;
  height: 18px;
  justify-content: center;
  margin: 0 0 0 auto;
  width: 18px
}

.bs-c-site-sidebar__list-icon.is-checkmark svg {
  fill: #fff;
  height: 8px;
  width: 11px
}

.bs-c-lang-selector__item-text {
  color: #9ea4ae;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-transform: capitalize
}

.is-active-locale .bs-c-lang-selector__item-text {
  color: #fff
}

.help-panel {
  background-color: #2b2740;
  box-sizing: border-box;
  color: #dfe4e8;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  transition: all .3s ease 0s;
  width: 340px;
  z-index: 104
}

.help-panel__header {
  align-items: center;
  background-color: #3c3955;
  display: flex;
  justify-content: space-between;
  padding: 14px 10px 14px 20px
}

.help-panel__title {
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  text-transform: uppercase
}

.help-panel__nav-link {
  align-items: center;
  border-bottom: 1px solid #3c3955;
  color: #d3d7db;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  padding: 18px 15px 18px 21px;
  -webkit-text-decoration: none;
  text-decoration: none;
  transition: all .35s ease
}

.help-panel__nav-item:first-child .help-panel__nav-link {
  border-top: 1px solid transparent;
  padding-top: 17px
}

.help-panel__nav-link:hover {
  background-color: #3c3955;
  color: #fff
}

.help-panel__nav-item:first-child .help-panel__nav-link:hover {
  border-top-color: #57546e
}

.help-panel__nav-link:hover .help-panel__nav-icon,
.help-panel__nav-link:hover .help-panel__nav-icon--arrow {
  fill: #fff
}

.help-panel__nav-link em {
  align-items: center;
  display: inline-flex;
  height: 21px;
  margin-right: 15px;
  width: 21px
}

.help-panel__nav-link em:before {
  color: inherit
}

.help-panel__nav-icon {
  fill: #d3d7db;
  height: 24px;
  margin-right: 15px;
  width: 24px
}

.help-panel__nav-icon--arrow {
  fill: #d3d7db;
  height: 14px;
  margin-left: auto;
  width: 8px
}

.help-panel__social-icons {
  padding: 0 20px 20px
}

.help-panel__social-icons .social-icons {
  gap: 8px
}

.help-panel__social-icons .social-icons__item {
  height: 25px;
  width: 25px
}

.help-panel__social-icons .social-icons__icon {
  background-color: #3c3955
}

.help-panel__social-icons .social-icons__icon:before {
  height: 13px;
  width: 13px
}

.help-panel__social-icons .social-icons__icon.is-social-vk:before {
  height: 20px;
  width: 20px
}

.lcqualitybadge {
  stroke: none;
  align-items: flex-end;
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  justify-content: center;
  margin-bottom: 10px
}

@media(max-height:640px) {
  .lcqualitybadge {
    display: none
  }
}

.lcqualitybadge [fill-rule=nonzero] {
  fill: #e31351
}

.lcqualitybadge rect {
  stroke: none
}

.c-help-content[data-v-5c6daa6e] {
  border-bottom: 1px solid #3c3955;
  padding: 18px 15px 18px 21px;
}

.c-help-content[data-v-5c6daa6e] {
  border-bottom: 1px solid #3c3955;
  padding: 18px 15px 18px 21px
}

.c-help-content__title[data-v-5c6daa6e] {
  align-items: center;
  display: flex;
  margin: 0 0 17px
}

.c-help-content__title-icon[data-v-5c6daa6e] {
  fill: #d3d7db;
  height: 25px;
  width: 26px
}

.c-help-content__title-text[data-v-5c6daa6e] {
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  margin-left: 16px
}

.c-help-content__text[data-v-5c6daa6e] {
  color: #dfe4e8;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin: 0 0 13px
}

.c-help-content__cta[data-v-5c6daa6e] {
  align-items: center;
  display: flex
}

.c-help-content__link[data-v-5c6daa6e] {
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
  -webkit-text-decoration: underline;
  text-decoration: underline
}

.c-help-content__link[data-v-5c6daa6e]:first-child {
  margin-right: 15px
}

.is-vip-user .c-help-content__title-icon[data-v-5c6daa6e] {
  fill: #ffd22f;
  height: 23px;
  width: 28px
}

.is-vip-user .c-help-content__title-text[data-v-5c6daa6e] {
  color: #ffd22f
}

.is-in-mobile-menu .c-help-content[data-v-5c6daa6e] {
  padding-left: 15px
}

.tournaments-panel {
  background-color: #2b2740;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  position: fixed;
  right: 0;
  top: 0;
  transition: all .3s ease;
  width: 340px;
  z-index: 104
}

@media(max-width:768px) {
  .tournaments-panel {
    display: none
  }
}

.tournaments-panel__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 9px 10px 15px 20px
}

.tournaments-panel__title {
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  text-transform: uppercase
}

.tournaments-panel__body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden
}

.tournaments-panel__counter {
  background-color: #3c3955;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px
}

.tournaments-panel__timer {
  color: #d3d7db;
  font-size: 12px;
  line-height: 14px
}

.tournaments-panel__timer .countdown-timer__icon {
  fill: #d3d7db
}

.tournaments-panel__results .bs-c-leaderboard__row:first-child {
  display: none
}

.tournaments-panel__results .bs-c-leaderboard__row.is-you,
.tournaments-panel__results .bs-c-leaderboard__row:nth-child(odd) {
  background: #3c3955
}

.tournaments-panel__results .bs-c-leaderboard__row.is-you {
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  box-shadow: 0 -4px 34px 0 rgba(22, 20, 33, .25)
}

.is-middle-slide {
  margin-left: 40px
}

.is-last-slide {
  margin-left: 80px
}

.tournament-panel__swiper {
  padding: 0 0 13px;
  position: relative
}

.tournament-panel__swiper .bs-c-swiper {
  padding-left: 9px
}

.tournament-panel__swiper-item {
  height: 132px;
  min-width: 242px;
  padding: 0 6px;
  position: relative;
  width: 242px
}

.tournament-panel__swiper-item.is-active .tournament-panel__swiper-box {
  border: 2px solid #ffd22f
}

.tournament-panel__swiper-box {
  border-radius: 10px;
  overflow: hidden;
  position: relative
}

.tournaments-panel-swiper-arrow.c-button {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  z-index: 2
}

.tournaments-panel-swiper-arrow.c-button.is-next {
  right: 10px
}

.tournaments-panel-swiper-arrow.c-button.is-prev {
  left: 10px
}

.tournament-panel__swiper-box__overlay {
  align-items: center;
  background: rgba(22, 20, 33, .7);
  border-radius: 10px;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%
}

.tournament-panel__swiper-box__overlay a {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-transform: uppercase
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity .35s
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0
}

.countdown-timer {
  align-items: center;
  display: flex
}

.countdown-timer.is-blocky {
  font-size: 10px;
  justify-content: center;
  line-height: 1.2
}

.countdown-timer.is-blocky.is-large {
  font-size: 16px;
  max-width: 660px;
  width: 100%
}

@media(max-width:1024px) {
  .countdown-timer.is-blocky.is-large {
    font-size: 14px
  }
}

.countdown-timer__icon {
  fill: #fff;
  height: 16px;
  margin-right: 8px;
  width: 16px
}

.is-inline .countdown-timer__label,
.is-inline .countdown-timer__value-block.is-day {
  margin-right: .25em
}

.countdown-timer__value,
.countdown-timer__value-block {
  display: flex
}

.is-blocky .countdown-timer__value {
  grid-gap: 20px;
  display: grid;
  grid-template-columns: repeat(4, auto)
}

.is-large.is-blocky .countdown-timer__value {
  grid-template-columns: repeat(4, 1fr);
  width: 100%
}

@media(max-width:1024px) {
  .is-large.is-blocky .countdown-timer__value {
    grid-gap: 10px
  }
}

.is-blocky .countdown-timer__value-block {
  align-items: center;
  display: flex;
  flex-direction: column
}

.is-large.is-blocky .countdown-timer__value-block {
  background: hsla(0, 0%, 100%, .15);
  border-radius: 10px;
  padding: 18px 0 25px
}

@media(max-width:1024px) {
  .is-large.is-blocky .countdown-timer__value-block {
    padding: 12px 0 18px
  }
}

.is-blocky .countdown-timer__value-time {
  font-size: 24px;
  font-weight: 900
}

.is-large.is-blocky .countdown-timer__value-time {
  font-size: 48px;
  margin-bottom: 10px
}

@media(max-width:1024px) {
  .is-large.is-blocky .countdown-timer__value-time {
    font-size: 32px;
    margin-bottom: 2px
  }
  .help-panel_trigger{
    margin-top:0px
  }
}

.help-panel__trigger[data-v-7ba5bd90] {
  align-items: center;
  background-color: #00bd71;
  border-radius: 6px 0 0 6px;
  cursor: pointer;
  display: flex;
  height: 99px;
  justify-content: center;
  margin-bottom: 5px;
  text-align: center;
  text-transform: uppercase;
  transition: background-color .3s ease;
  white-space: nowrap;
  width: 40px
}

.help-panel__trigger>span[data-v-7ba5bd90] {
  color: #fff;
  font-size: 22px;
  font-weight: 400;
  margin: 0;
  text-align: center;
  transform: rotate(90deg);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none
}

.lang-ru .help-panel__trigger>span[data-v-7ba5bd90] {
  font-size: 16px
}

.lang-pt-BR .help-panel__trigger>span[data-v-7ba5bd90] {
  font-size: 20px
}

.help-panel__trigger.is-out[data-v-7ba5bd90] {
  right: -50px
}

.help-panel__trigger.clicked[data-v-7ba5bd90] {
  right: -44px
}

.help-panel__trigger[data-v-7ba5bd90]:hover {
  background-color: #0dd182
}

.tournaments-panel__trigger[data-v-7ba5bd90] {
  align-items: center;
  background: #e5b400;
  border-radius: 6px 0 0 6px;
  cursor: pointer;
  display: flex;
  font-size: 18px;
  height: 40px;
  justify-content: center;
  margin-bottom: 5px;
  text-align: center;
  transition: all .3s ease;
  width: 40px
}

.tournaments-panel__trigger.is-out[data-v-7ba5bd90] {
  right: -44px
}

.tournaments-panel__trigger.is-out span[data-v-7ba5bd90] {
  opacity: 0
}

.tournaments-panel__trigger>span[data-v-7ba5bd90] {
  font-size: 24px
}

.os-win .tournaments-panel__trigger>span[data-v-7ba5bd90] {
  transform: translateY(5%)
}

.tournaments-panel__trigger>span[data-v-7ba5bd90]:before {
  color: #fff
}

.page-users_sign_up .tournaments-panel__trigger[data-v-7ba5bd90] {
  display: none
}

:-webkit-full-screen .tournaments-panel__trigger[data-v-7ba5bd90] {
  display: none
}

.tournaments-panel__trigger.is-panel-opened[data-v-7ba5bd90] {
  right: -44px
}

.tournaments-panel__trigger-icon[data-v-7ba5bd90] {
  fill: #fff;
  height: 18px;
  width: 20px
}

.lang-selector[data-v-7ba5bd90] {
  align-content: stretch;
  align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 44px;
  justify-content: flex-start;
  margin-bottom: 5px;
  position: absolute;
  transform: translate3d(-3px, 0, 0);
  transition: transform .5s;
  white-space: nowrap
}

@media(max-width:768px) {
  .lang-selector[data-v-7ba5bd90] {
    display: none
  }
}

.lang-selector.is-opened {
  transform: translate3d(-304px, 0, 0);
}

.lang-selector.is-opened a:not(:last-child) .c-flag-icon[data-v-7ba5bd90] {
  border-radius: 6px
}

.lang-selector a[data-v-7ba5bd90] {
  display: inline-block;
  height: 40px;
  margin-left: 3px;
  order: 2;
  -webkit-text-decoration: none;
  text-decoration: none;
  width: 40px
}

.lang-selector a.nuxt-link-active[data-v-7ba5bd90] {
  order: 1
}

.lang-selector .c-flag-icon[data-v-7ba5bd90] {
  border-radius: 6px 0 0 6px;
  height: 40px;
  width: 40px
}

.is-desktop .bs-c-lang-selector .is-active-locale[data-v-7ba5bd90] {
  display: none
}

.is-desktop .bs-c-lang-selector .bs-c-lang-selector__item-link[data-v-7ba5bd90] {
  padding-left: 10px
}

.bs-c-lang-selector__item[data-v-7ba5bd90] {
  align-items: center;
  display: flex;
  min-height: 50px
}

.bs-c-lang-selector__item-link[data-v-7ba5bd90] {
  align-items: center;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: flex;
  height: 100%;
  min-height: 40px;
  padding: 0 13px;
  -webkit-text-decoration: none;
  text-decoration: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  width: 100%
}

@media(max-width:1366px) {
  .bs-c-lang-selector__item-link[data-v-7ba5bd90] {
    padding: 0 20px
  }
}

@media(hover:hover) {
  .bs-c-lang-selector__item-link[data-v-7ba5bd90]:hover {
    background: radial-gradient(62.27% 184.22% at 87.42% 42.5%, #342f4b 0, #2b2740 100%)
  }

  .bs-c-lang-selector__item-link:hover .bs-c-lang-selector__item-text[data-v-7ba5bd90] {
    color: #fff;
    font-weight: 400
  }
}

.bs-c-site-sidebar__list-icon.is-checkmark[data-v-7ba5bd90] {
  align-items: center;
  background: #00bd71;
  border-radius: 50%;
  display: flex;
  height: 18px;
  justify-content: center;
  margin: 0 0 0 auto;
  width: 18px
}

.bs-c-site-sidebar__list-icon.is-checkmark svg[data-v-7ba5bd90] {
  fill: #fff;
  height: 8px;
  width: 11px
}

.bs-c-lang-selector__item-text[data-v-7ba5bd90] {
  color: #9ea4ae;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-transform: capitalize
}

.is-active-locale .bs-c-lang-selector__item-text[data-v-7ba5bd90] {
  color: #fff
}

.help-panel[data-v-7ba5bd90] {
  background-color: #2b2740;
  box-sizing: border-box;
  color: #dfe4e8;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  transition: all .3s ease 0s;
  width: 340px;
  z-index: 104
}

.help-panel__header[data-v-7ba5bd90] {
  align-items: center;
  background-color: #3c3955;
  display: flex;
  justify-content: space-between;
  padding: 14px 10px 14px 20px
}

.help-panel__title[data-v-7ba5bd90] {
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  text-transform: uppercase
}

.help-panel__nav-link[data-v-7ba5bd90] {
  align-items: center;
  border-bottom: 1px solid #3c3955;
  color: #d3d7db;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  padding: 18px 15px 18px 21px;
  -webkit-text-decoration: none;
  text-decoration: none;
  transition: all .35s ease
}

.help-panel__nav-item:first-child .help-panel__nav-link[data-v-7ba5bd90] {
  border-top: 1px solid transparent;
  padding-top: 17px
}

.help-panel__nav-link[data-v-7ba5bd90]:hover {
  background-color: #3c3955;
  color: #fff
}

.help-panel__nav-item:first-child .help-panel__nav-link[data-v-7ba5bd90]:hover {
  border-top-color: #57546e
}

.help-panel__nav-link:hover .help-panel__nav-icon[data-v-7ba5bd90],
.help-panel__nav-link:hover .help-panel__nav-icon--arrow[data-v-7ba5bd90] {
  fill: #fff
}

.help-panel__nav-link em[data-v-7ba5bd90] {
  align-items: center;
  display: inline-flex;
  height: 21px;
  margin-right: 15px;
  width: 21px
}

.help-panel__nav-link em[data-v-7ba5bd90]:before {
  color: inherit
}

.help-panel__nav-icon[data-v-7ba5bd90] {
  fill: #d3d7db;
  height: 24px;
  margin-right: 15px;
  width: 24px
}

.help-panel__nav-icon--arrow[data-v-7ba5bd90] {
  fill: #d3d7db;
  height: 14px;
  margin-left: auto;
  width: 8px
}

.help-panel__social-icons[data-v-7ba5bd90] {
  padding: 0 20px 20px
}

.help-panel__social-icons .social-icons[data-v-7ba5bd90] {
  gap: 8px
}

.help-panel__social-icons .social-icons__item[data-v-7ba5bd90] {
  height: 25px;
  width: 25px
}

.help-panel__social-icons .social-icons__icon[data-v-7ba5bd90] {
  background-color: #3c3955
}

.help-panel__social-icons .social-icons__icon[data-v-7ba5bd90]:before {
  height: 13px;
  width: 13px
}

.help-panel__social-icons .social-icons__icon.is-social-vk[data-v-7ba5bd90]:before {
  height: 20px;
  width: 20px
}

.lcqualitybadge[data-v-7ba5bd90] {
  stroke: none;
  align-items: flex-end;
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  justify-content: center;
  margin-bottom: 10px
}

@media(max-height:640px) {
  .lcqualitybadge[data-v-7ba5bd90] {
    display: none
  }
}

.lcqualitybadge [fill-rule=nonzero][data-v-7ba5bd90] {
  fill: #e31351
}

.lcqualitybadge rect[data-v-7ba5bd90] {
  stroke: none
}

.c-help-content[data-v-5c6daa6e][data-v-7ba5bd90] {
  border-bottom: 1px solid #3c3955;
  padding: 18px 15px 18px 21px;
}

.c-help-content[data-v-5c6daa6e][data-v-7ba5bd90] {
  border-bottom: 1px solid #3c3955;
  padding: 18px 15px 18px 21px
}

.c-help-content__title[data-v-5c6daa6e][data-v-7ba5bd90] {
  align-items: center;
  display: flex;
  margin: 0 0 17px
}

.c-help-content__title-icon[data-v-5c6daa6e][data-v-7ba5bd90] {
  fill: #d3d7db;
  height: 25px;
  width: 26px
}

.c-help-content__title-text[data-v-5c6daa6e][data-v-7ba5bd90] {
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  margin-left: 16px
}

.c-help-content__text[data-v-5c6daa6e][data-v-7ba5bd90] {
  color: #dfe4e8;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin: 0 0 13px
}

.c-help-content__cta[data-v-5c6daa6e][data-v-7ba5bd90] {
  align-items: center;
  display: flex
}

.c-help-content__link[data-v-5c6daa6e][data-v-7ba5bd90] {
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
  -webkit-text-decoration: underline;
  text-decoration: underline
}

.c-help-content__link[data-v-5c6daa6e][data-v-7ba5bd90]:first-child {
  margin-right: 15px
}

.is-vip-user .c-help-content__title-icon[data-v-5c6daa6e][data-v-7ba5bd90] {
  fill: #ffd22f;
  height: 23px;
  width: 28px
}

.is-vip-user .c-help-content__title-text[data-v-5c6daa6e][data-v-7ba5bd90] {
  color: #ffd22f
}

.is-in-mobile-menu .c-help-content[data-v-5c6daa6e][data-v-7ba5bd90] {
  padding-left: 15px
}

.tournaments-panel[data-v-7ba5bd90] {
  background-color: #2b2740;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  position: fixed;
  right: 0;
  top: 0;
  transition: all .3s ease;
  width: 340px;
  z-index: 104
}

@media(max-width:768px) {
  .tournaments-panel[data-v-7ba5bd90] {
    display: none
  }
}

.tournaments-panel__header[data-v-7ba5bd90] {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 9px 10px 15px 20px
}

.tournaments-panel__title[data-v-7ba5bd90] {
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  text-transform: uppercase
}

.tournaments-panel__body[data-v-7ba5bd90] {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden
}

.tournaments-panel__counter[data-v-7ba5bd90] {
  background-color: #3c3955;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px
}

.tournaments-panel__timer[data-v-7ba5bd90] {
  color: #d3d7db;
  font-size: 12px;
  line-height: 14px
}

.tournaments-panel__timer .countdown-timer__icon[data-v-7ba5bd90] {
  fill: #d3d7db
}

.tournaments-panel__results .bs-c-leaderboard__row[data-v-7ba5bd90]:first-child {
  display: none
}

.tournaments-panel__results .bs-c-leaderboard__row.is-you[data-v-7ba5bd90],
.tournaments-panel__results .bs-c-leaderboard__row[data-v-7ba5bd90]:nth-child(odd) {
  background: #3c3955
}

.tournaments-panel__results .bs-c-leaderboard__row.is-you[data-v-7ba5bd90] {
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  box-shadow: 0 -4px 34px 0 rgba(22, 20, 33, .25)
}

.is-middle-slide[data-v-7ba5bd90] {
  margin-left: 40px
}

.is-last-slide[data-v-7ba5bd90] {
  margin-left: 80px
}

.tournament-panel__swiper[data-v-7ba5bd90] {
  padding: 0 0 13px;
  position: relative
}

.tournament-panel__swiper .bs-c-swiper[data-v-7ba5bd90] {
  padding-left: 9px
}

.tournament-panel__swiper-item[data-v-7ba5bd90] {
  height: 132px;
  min-width: 242px;
  padding: 0 6px;
  position: relative;
  width: 242px
}

.tournament-panel__swiper-item.is-active .tournament-panel__swiper-box[data-v-7ba5bd90] {
  border: 2px solid #ffd22f
}

.tournament-panel__swiper-box[data-v-7ba5bd90] {
  border-radius: 10px;
  overflow: hidden;
  position: relative
}

.tournaments-panel-swiper-arrow.c-button[data-v-7ba5bd90] {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  z-index: 2
}

.tournaments-panel-swiper-arrow.c-button.is-next[data-v-7ba5bd90] {
  right: 10px
}

.tournaments-panel-swiper-arrow.c-button.is-prev[data-v-7ba5bd90] {
  left: 10px
}

.tournament-panel__swiper-box__overlay[data-v-7ba5bd90] {
  align-items: center;
  background: rgba(22, 20, 33, .7);
  border-radius: 10px;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%
}

.tournament-panel__swiper-box__overlay a[data-v-7ba5bd90] {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-transform: uppercase
}

.fade-in-enter-active[data-v-7ba5bd90],
.fade-in-leave-active[data-v-7ba5bd90] {
  transition: opacity .35s
}

.fade-in-enter[data-v-7ba5bd90],
.fade-in-leave-to[data-v-7ba5bd90] {
  opacity: 0
}

.countdown-timer[data-v-7ba5bd90] {
  align-items: center;
  display: flex
}

.countdown-timer.is-blocky[data-v-7ba5bd90] {
  font-size: 10px;
  justify-content: center;
  line-height: 1.2
}

.countdown-timer.is-blocky.is-large[data-v-7ba5bd90] {
  font-size: 16px;
  max-width: 660px;
  width: 100%
}

@media(max-width:1024px) {
  .countdown-timer.is-blocky.is-large[data-v-7ba5bd90] {
    font-size: 14px
  }
}

.countdown-timer__icon[data-v-7ba5bd90] {
  fill: #fff;
  height: 16px;
  margin-right: 8px;
  width: 16px
}

.is-inline .countdown-timer__label[data-v-7ba5bd90],
.is-inline .countdown-timer__value-block.is-day[data-v-7ba5bd90] {
  margin-right: .25em
}

.countdown-timer__value[data-v-7ba5bd90],
.countdown-timer__value-block[data-v-7ba5bd90] {
  display: flex
}

.is-blocky .countdown-timer__value[data-v-7ba5bd90] {
  grid-gap: 20px;
  display: grid;
  grid-template-columns: repeat(4, auto)
}

.is-large.is-blocky .countdown-timer__value[data-v-7ba5bd90] {
  grid-template-columns: repeat(4, 1fr);
  width: 100%
}

@media(max-width:1024px) {
  .is-large.is-blocky .countdown-timer__value[data-v-7ba5bd90] {
    grid-gap: 10px
  }
}

.is-blocky .countdown-timer__value-block[data-v-7ba5bd90] {
  align-items: center;
  display: flex;
  flex-direction: column
}

.is-large.is-blocky .countdown-timer__value-block[data-v-7ba5bd90] {
  background: hsla(0, 0%, 100%, .15);
  border-radius: 10px;
  padding: 18px 0 25px
}

@media(max-width:1024px) {
  .is-large.is-blocky .countdown-timer__value-block[data-v-7ba5bd90] {
    padding: 12px 0 18px
  }
}

.is-blocky .countdown-timer__value-time[data-v-7ba5bd90] {
  font-size: 24px;
  font-weight: 900
}

.is-large.is-blocky .countdown-timer__value-time[data-v-7ba5bd90] {
  font-size: 48px;
  margin-bottom: 10px
}

@media(max-width:1024px) {
  .is-large.is-blocky .countdown-timer__value-time[data-v-7ba5bd90] {
    font-size: 32px;
    margin-bottom: 2px
  }
}

.bs-c-leaderboard {
  color: #fff
}

.bs-c-leaderboard.is-large {
  height: 100%;
  overflow-y: auto;
  position: relative
}

.is-desktop .bs-c-page .bs-c-leaderboard {
  max-height: 609px
}

.bs-c-leaderboard__row {
  align-items: center;
  display: grid;
  min-height: 40px
}

.is-small .bs-c-leaderboard__row {
  border-bottom: 1px solid hsla(0, 0%, 100%, .15);
  grid-template-columns: auto 1fr 33.33333% 33.33333%
}

@media(max-width:1024px) {
  #promotions-slider .is-small .bs-c-leaderboard__row {
    font-size: 13px;
    min-height: 32px
  }
}

.is-large .bs-c-leaderboard__row {
  grid-template-columns: .7fr repeat(3, 1fr);
  padding: 10px 15px
}

.is-large .bs-c-leaderboard__row:first-child {
  display: block
}

.is-large .bs-c-leaderboard__row.is-you {
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  background: hsla(0, 0%, 100%, .15);
  bottom: 0;
  left: 0;
  position: sticky;
  width: 100%
}

.is-slot-wars .is-large .bs-c-leaderboard__row.is-you {
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  background: #573d6c
}

.is-table-wars .is-large .bs-c-leaderboard__row.is-you {
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  background: #42605a
}

.is-small .bs-c-leaderboard__column:first-child {
  margin-right: .5ch
}

.bs-c-leaderboard__column:last-child {
  font-weight: 600;
  text-align: right
}

.is-small .bs-c-leaderboard__column:last-child {
  color: #ffd22f
}

.is-small .bs-c-leaderboard__column.is-points {
  font-weight: 600;
  text-align: center
}

.is-middle-slide {
  margin-left: 40px
}

.is-last-slide {
  margin-left: 80px
}

.tournament-panel__swiper {
  padding: 0 0 13px;
  position: relative
}

.tournament-panel__swiper .bs-c-swiper {
  padding-left: 9px
}

.tournament-panel__swiper-item {
  height: 132px;
  min-width: 242px;
  padding: 0 6px;
  position: relative;
  width: 242px
}

.tournament-panel__swiper-item.is-active .tournament-panel__swiper-box {
  border: 2px solid #ffd22f
}

.tournament-panel__swiper-box {
  border-radius: 10px;
  overflow: hidden;
  position: relative
}

.tournaments-panel-swiper-arrow.c-button {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  z-index: 2
}

.tournaments-panel-swiper-arrow.c-button.is-next {
  right: 10px
}

.tournaments-panel-swiper-arrow.c-button.is-prev {
  left: 10px
}

.tournament-panel__swiper-box__overlay {
  align-items: center;
  background: rgba(22, 20, 33, .7);
  border-radius: 10px;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%
}

.tournament-panel__swiper-box__overlay a {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-transform: uppercase
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity .35s
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0
}

.tournaments-panel {
  background-color: #2b2740;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  position: fixed;
  right: 0;
  top: 0;
  transition: all .3s ease;
  width: 340px;
  z-index: 104
}

@media(max-width:768px) {
  .tournaments-panel {
    display: none
  }
}

.tournaments-panel__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 9px 10px 15px 20px
}

.tournaments-panel__title {
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  text-transform: uppercase
}

.tournaments-panel__body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden
}

.tournaments-panel__counter {
  background-color: #3c3955;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px
}

.tournaments-panel__timer {
  color: #d3d7db;
  font-size: 12px;
  line-height: 14px
}

.tournaments-panel__timer .countdown-timer__icon {
  fill: #d3d7db
}

.tournaments-panel__results .bs-c-leaderboard__row:first-child {
  display: none
}

.tournaments-panel__results .bs-c-leaderboard__row.is-you,
.tournaments-panel__results .bs-c-leaderboard__row:nth-child(odd) {
  background: #3c3955
}

.tournaments-panel__results .bs-c-leaderboard__row.is-you {
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  box-shadow: 0 -4px 34px 0 rgba(22, 20, 33, .25)
}
.tournaments-panel__results li{
  text-align: left;
}
@import '~@fortawesome/fontawesome-free/css/all.css';

</style>

